module.exports = __webpack_public_path__ + "static/media/basic-profile-img-small.533cc790.svg";